import React, { Fragment } from 'react';
import { AllhomesListingBadgesGraphQL } from '@domain-group/fe-co-allhomes-listing-badges';
import { withEventBoundary, useSendEvent } from '@domain-group/fe-co-analytics';
import { Address } from './address';
import * as styles from './property-identifier.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var PropertyIdentifierAppearance = {
  RESIDENTIAL: 'RESIDENTIAL',
  NEW_DEVELOPMENT: 'NEW_DEVELOPMENT',
  COMMERCIAL: 'COMMERCIAL',
  OFF_MARKET: 'OFF_MARKET',
  EARLY_ACCESS: 'EARLY_ACCESS'
};
var Headline = styles.Headline,
  DevelopmentHeadline = styles.DevelopmentHeadline,
  ResidentialAddress = styles.ResidentialAddress,
  NonResidentialAddress = styles.NonResidentialAddress,
  ResidentialPrice = styles.ResidentialPrice,
  NonResidentialPrice = styles.NonResidentialPrice,
  Identifier = styles.Identifier,
  OffMarketAddress = styles.OffMarketAddress,
  Header = styles.Header;
export var BasePropertyIdentifier = _ref => {
  var property = _ref.property,
    price = _ref.price,
    address = _ref.address,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'RESIDENTIAL' : _ref$appearance,
    headline = _ref.headline,
    tagline = _ref.tagline,
    _ref$onLogoClicked = _ref.onLogoClicked,
    onLogoClicked = _ref$onLogoClicked === void 0 ? () => {} : _ref$onLogoClicked;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onAgencyLogoClick = agency => {
    onLogoClicked(agency);
    sendEvent('logo-click', {
      agencyId: agency.agencyId,
      agencyName: agency.name
    });
  };
  var buildBadges = () => ___EmotionJSX("div", null, ___EmotionJSX(AllhomesListingBadgesGraphQL, {
    property: property,
    labelType: "full",
    size: "large"
  }));
  var buildNewDevHeadlineContents = () => ___EmotionJSX(Fragment, null, ___EmotionJSX(DevelopmentHeadline, null, headline), ___EmotionJSX("p", {
    css: styles.developmentAddress
  }, address.suburb), ___EmotionJSX("p", {
    css: styles.tagline
  }, tagline), ___EmotionJSX("p", {
    "data-testid": "price",
    css: styles.developmentPrice
  }, price));
  var buildCommercialHeadlineContents = () => ___EmotionJSX(Fragment, null, buildBadges(), ___EmotionJSX(Headline, null, headline));
  var buildResidentialHeadlineContents = () => ___EmotionJSX(Fragment, null, buildBadges(), ___EmotionJSX(ResidentialPrice, {
    "data-testid": "price"
  }, price));
  var buildHeader = () => {
    var _property$agencies;
    var agenciesWithLogos = ((_property$agencies = property.agencies) === null || _property$agencies === void 0 ? void 0 : _property$agencies.filter(each => each.images.tinyLogo)) || [];
    return ___EmotionJSX(Header, null, ___EmotionJSX("div", {
      css: (appearance !== PropertyIdentifierAppearance.COMMERCIAL || headline) && styles.headlineContainer
    }, appearance === PropertyIdentifierAppearance.NEW_DEVELOPMENT && buildNewDevHeadlineContents(), appearance === PropertyIdentifierAppearance.COMMERCIAL && buildCommercialHeadlineContents(), [PropertyIdentifierAppearance.RESIDENTIAL, PropertyIdentifierAppearance.EARLY_ACCESS].some(type => type === appearance) && buildResidentialHeadlineContents()), ___EmotionJSX("div", {
      css: styles.agencyLogoContainer
    }, agenciesWithLogos.map(agency => ___EmotionJSX("img", {
      key: agency.agencyId,
      onClick: () => onAgencyLogoClick(agency),
      css: styles.agencyLogo,
      src: agency.images.tinyLogo,
      alt: "agency logo",
      "data-testid": "agency-logo",
      role: "presentation"
    }))));
  };
  return ___EmotionJSX(Identifier, null, appearance === PropertyIdentifierAppearance.COMMERCIAL && ___EmotionJSX(Fragment, null, buildHeader(), ___EmotionJSX(NonResidentialAddress, {
    css: !headline && styles.addressWrap
  }, ___EmotionJSX(Address, address)), ___EmotionJSX(NonResidentialPrice, {
    "data-testid": "price",
    as: "h2"
  }, price)), [PropertyIdentifierAppearance.RESIDENTIAL, PropertyIdentifierAppearance.EARLY_ACCESS].some(type => type === appearance) && ___EmotionJSX(Fragment, null, buildHeader(), ___EmotionJSX(ResidentialAddress, null, ___EmotionJSX(Address, address))), appearance === PropertyIdentifierAppearance.OFF_MARKET && ___EmotionJSX(OffMarketAddress, null, ___EmotionJSX(Address, {
    streetName: address.streetName,
    appearance: "two-lines"
  }), ___EmotionJSX(Address, {
    suburb: address.suburb,
    state: address.state,
    postcode: address.postcode,
    appearance: "two-lines"
  })), appearance === PropertyIdentifierAppearance.NEW_DEVELOPMENT && buildHeader());
};
export var PropertyIdentifier = withEventBoundary('agency')(BasePropertyIdentifier);